import React from 'react';

const Context = React.createContext({
  basePath: '',
});

export default Context;
